import { AnalyticsBrowser } from '@segment/analytics-next';

// AnalyticsBrowser.load fires a settings request whatever the write key is, so
// a blank key does not mean "analytics off" — it means a request to
// cdn.segment.com/v1/projects//settings failing on every page load. The e2e
// build ships a blank key deliberately (.env.e2e) and any environment can end
// up with one, so decide it here: no key, no Segment.
//
// The stub covers the whole surface call sites use (addIdentity aliases this
// import as `analyticsBrowser`). `ready` deliberately never invokes its
// callback: everything inside it is analytics — Segment identify/group, the
// session middleware, and Mixpanel's init — so not firing it is what "off"
// means, and it keeps Mixpanel out of the build too.
const noopAnalytics = {
  track: () => undefined,
  page: () => undefined,
  identify: () => undefined,
  group: () => undefined,
  reset: () => undefined,
  ready: () => undefined,
  addSourceMiddleware: () => undefined,
};

export const analytics = process.env.REACT_APP_SEGMENT_SCRIPT
  ? AnalyticsBrowser.load({ writeKey: process.env.REACT_APP_SEGMENT_SCRIPT })
  : noopAnalytics;
